import { render } from "./advisorCarousel.vue?vue&type=template&id=4055a782"
import script from "./advisorCarousel.vue?vue&type=script&lang=js"
export * from "./advisorCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__